/**
 * @group Data
 * @summary Payment method type values for patient payment methods
 * 
 * @remarks
 * This constant contains the possible payment method types that patients can use,
 * used to categorize different payment methods for display and management purposes.
 * 
 * @example
 * ```typescript
 * import { PAYMENT_METHOD_TYPE } from '@shared/db';
 * 
 * function isBankPayment(type: string): boolean {
 *   return type === PAYMENT_METHOD_TYPE.BANK_ACCOUNT || type === PAYMENT_METHOD_TYPE.DEBIT_ORDER;
 * }
 * 
 * function isCardPayment(type: string): boolean {
 *   return type === PAYMENT_METHOD_TYPE.CARD;
 * }
 * ```
 */
export const PAYMENT_METHOD_TYPE = {
  DEBIT_ORDER: 'debit_order',
  BANK_ACCOUNT: 'bank_account',
  CARD: 'card'
} as const;
